import React from 'react';

function OpenAccount() {
    return ( 
        <div className="container p-3 p-md-5 mb-4mb-md-5">
            <div className="row text-center">
                <h1 className="mt-3 mt-md-5">Open a Zerodha account</h1>
                <p>Modern platforms and apps, ₹0 investments, and flat ₹20 intraday and F&O trades.</p>
                <button className="p-1 p-md-2 btn btn-primary  fs-6 mb-4 mb-md-5 signup-button">Signup for free</button>
            </div>
        </div>
     );
}

export default OpenAccount;